import { createReducer, on } from '@ngrx/store';
import * as fromResourcesActions from '../actions/resources.actions';
import { ResourceFirebaseResponse } from '../../models/resources.model';

export interface ResourcesState {
    data: ResourceFirebaseResponse[];
    loaded: boolean;
    loading: boolean;
    error: string;
    selectedDoubtId: string;
}

export const initialState: ResourcesState = {
    data: undefined as any,
    loaded: false,
    loading: false,
    error: '',
    selectedDoubtId: ''
};

export const resourcesReducer = createReducer(
    initialState,
    on(fromResourcesActions.LoadResourcesAction, (state) => ({
      ...state,
      loading: true
    })),
    on(fromResourcesActions.LoadResourcesSuccessAction, (state, { data }) => ({
      ...state,
      data,
      loaded: true,
      loading: false
    })),
    on(fromResourcesActions.LoadResourcesFailAction, (state, { error }) => ({
      ...state,
      error: error.message
    }))
  );
